<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<a id="title90"></a>
<div class="p-c-br"><span>Special thanks to <br/>Tom Valesky (again) and <br/>Gerald Molnar for their <br/>marksmen’s eyes for <br/>weapons errors.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429967365_ack01.vue?9281a456